export default process.env.VUE_APP_IS_BROKER == 1